module.exports = __webpack_public_path__ + "img/qa.c58b6395.svg";